export default function Footer() {
  const footerLinks = [
    {
      title: '快速导航',
      items: [
        { label: '精选专题', href: '#index' },
        { label: '热播榜单', href: '#ranking' },
        { label: '精彩预告', href: '#media' },
        { label: '焦点专题', href: '#carousel' },
        { label: '最新更新', href: '#updates' },
      ],
    },
    {
      title: '帮助中心',
      items: [
        { label: '常见问题', href: '#faq' },
        { label: '联系我们', href: '#contact' },
        { label: '关于午马', href: '#about' },
        { label: '手机观影', href: '#app' },
      ],
    },
  ];

  return (
    <footer id="footer" className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-fill text-background-50 text-lg"></i>
                </span>
                <span className="font-heading text-xl font-bold text-white">午马影院</span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed max-w-md mb-4">
                午马影院致力于为广大影迷提供最新电影免费在线观看服务。高清画质、智能秒播、海量片库，涵盖动作、科幻、喜剧、悬疑、动画等全类型电影全集播放。每日同步更新院线新片与经典老片，让您随时随地畅享流畅观影体验。
              </p>
              <div className="flex items-center gap-4 text-foreground-500 text-sm">
                <span>每日更新</span>
                <span className="w-1 h-1 rounded-full bg-foreground-600"></span>
                <span>1080P 高清</span>
                <span className="w-1 h-1 rounded-full bg-foreground-600"></span>
                <span>秒播不缓冲</span>
              </div>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h3 className="text-sm font-semibold text-white mb-3">{group.title}</h3>
                <ul className="space-y-2">
                  {group.items.map((item) => (
                    <li key={item.label}>
                      <a
                        href={item.href}
                        onClick={(e) => {
                          e.preventDefault();
                          document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                        }}
                        className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                      >
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800/50">
            <div className="mb-6">
              <h3 className="text-sm font-semibold text-foreground-500 mb-3">合作伙伴</h3>
              <p className="text-xs text-foreground-600">诚邀各大影视平台与内容方合作共赢</p>
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-600">
                &copy; {new Date().getFullYear()} 午马影院 wumacinema.com — 最新电影免费在线观看
              </p>
              <p className="text-xs text-foreground-700">
                本站内容仅供学习交流，请支持正版影片
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}